const importProcessPaths = {
  IMPORT_SEARCH: (venueId) => `search?venueId=${venueId}`,
  DELETE_IMPORT: ({ id, venueId }) => `delete/${id}?venueId=${venueId}`,
};

export default importProcessPaths;
